import React from "react";
import { Button as AntButton } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: "buttonWhite" | "buttonCore" | "buttonOrange" | "buttonBlue";
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
  icon?: React.ReactNode;
}

const variantStyles = {
  buttonWhite: "bg-white text-black border border-gray-300 hover:bg-gray-50",

  buttonCore:
    "bg-buttonCore text-white border border-buttonCore hover:bg-themeCore hover:text-white",

  buttonOrange:
    "bg-buttonOrange text-white border border-buttonOrange hover:bg-themeOrange",

  buttonBlue:
    "bg-buttonBlue text-white border border-buttonBlue hover:bg-themeBlue",
};

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  variant = "buttonBlue",
  isLoading = false,
  disabled = false,
  className = "",
  icon,
}) => {
  return (
    <AntButton
      type="default"
      size="large"
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`
        h-10
        px-6
        rounded-md
        font-semibold
        text-sm
        inline-flex
        items-center
        justify-center
        shadow-none
        ${variantStyles[variant]}
        ${className}
      `}
    >
      {isLoading ? (
        <LoadingOutlined />
      ) : (
        <>
          {icon && <span className="mr-2">{icon}</span>}
          {children}
        </>
      )}
    </AntButton>
  );
};

export default Button;
